module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-verify",
    attrs: {
      "id": "slideVerify",
      "onselectstart": "return false;"
    }
  }, [_c('canvas', {
    ref: "canvas",
    attrs: {
      "width": _vm.w,
      "height": _vm.h
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-verify-refresh-icon",
    on: {
      "click": _vm.refresh
    }
  }), _vm._v(" "), _c('canvas', {
    ref: "block",
    staticClass: "slide-verify-block",
    attrs: {
      "width": _vm.w,
      "height": _vm.h
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-verify-slider",
    class: {
      'container-active': _vm.containerActive, 'container-success': _vm.containerSuccess, 'container-fail': _vm.containerFail
    }
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask",
    style: ({
      width: _vm.sliderMaskWidth
    })
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask-item",
    style: ({
      left: _vm.sliderLeft
    }),
    on: {
      "mousedown": _vm.sliderDown,
      "touchstart": _vm.touchStartEvent,
      "touchmove": _vm.touchMoveEvent,
      "touchend": _vm.touchEndEvent
    }
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask-item-icon"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "slide-verify-slider-text"
  }, [_vm._v(_vm._s(_vm.sliderText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cfdd76e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/slide-verify.vue
// module id = 1119
// module chunks = 1